import React from 'react';

/** Элемент списка: `[item]…[/item]` */
export const ListItem: React.FC<React.PropsWithChildren> = ({children}) => <li>{children}</li>;
